import toastr from 'toastr';

// successAlert for fire toast/...

export const successAlert = (msg = 'No Msg') => {
  toastr.options = {
    positionClass: 'toast-top-right',
    closeButton: true,
    timeOut: 5000, // Set the timeout to 0 to make notifications stay indefinitely
    toastClass: "animate__animated animate__backInLeft"
  };
  toastr.success(msg);
}

//successAlert for fire toast/...
export const errorAlert = (msg = 'No Msg') => {
  toastr.options = {
    positionClass: 'toast-top-right',
    closeButton: true,
    timeOut: 5000, // Set the timeout to 0 to make notifications stay indefinitely
    toastClass: "animate__animated animate__backInLeft"
  };
  toastr.error(msg);
}



//successAlert for fire toast/...
export const infoAlert = (msg = 'No Msg') => {
  toastr.options = {
    positionClass: 'toast-top-right',
    closeButton: true,
    timeOut: 5000, // Set the timeout to 0 to make notifications stay indefinitely
    toastClass: "animate__animated animate__backInLeft"
  };
  toastr.info(msg);
}